<!--

== Base Logo

Props:

    > width
    Largura da logo, podendo ser usado qualquer medida CSS (Ex: px, em, %).

-->

<template>
    <p class="w-100 text-center">
        <a href="http://easydelivery.com.br">
            <img class="img-fluid" :style="`width: ${width}`" src="@/assets/img/easy-delivery.svg" alt="logo-easy">
        </a>
    </p>
</template>

<script>
export default {
    props: {
        width: {required: true}
    }
}
</script>